
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  ChartStore,
  CommonStore,
  ConfigurationStore,
  SensorStore
} from '@/store/modules';
import SvgIcon from '@/components/SvgIcon.vue';
import BaseChart from '@/components/Charts/Base.vue';
import Highcharts, { Options, XAxisOptions } from 'highcharts';

@Component({
  components: {
    SvgIcon,
    BaseChart
  }
})
export default class ModelerAlbums extends Vue {
  $refs!: {
    sensorProfileGraph: InstanceType<typeof BaseChart>;
  };

  sensorId = 0;
  sensorLocationId = 0;
  loading = false;

  startDateVisible = false;
  endDateVisible = false;

  get sensorProfileGraph() {
    return SensorStore.SensorProfileGraph;
  }

  get SensorProfileChart() {
    const chartOptions: Options = ChartStore.SplineChartDataWithDots(
      this.sensorProfileGraph
    );
    const xAxis: XAxisOptions = {
      type: 'datetime',
      labels: {
        formatter: function() {
          return Highcharts.dateFormat('%b-%d', this.value as number);
        }
      }
    };

    chartOptions.xAxis = xAxis;

    chartOptions.tooltip = {
      xDateFormat: '%Y-%m-%d',
      formatter: function() {
        return 'The value for <b>' + this.x + '</b> is <b>' + this.y + '</b>';
      }
    };

    if (chartOptions.plotOptions) {
      chartOptions.plotOptions.series = {
        dataLabels: {
          enabled: false,
          overflow: 'justify'
        }
      };
      if (chartOptions.plotOptions.series) {
        chartOptions.plotOptions.series.tooltip = {
          xDateFormat: '%Y/%m/%d',
          pointFormatter: function() {
            // const date = new Date(this.x).toJSON().split('T')[0];
            return `<strong>${this.series.name}:</strong> ${this.y} <br>`;
          }
        };
      }
    }
    const colors = [
      '#7cb5ec',
      '#434348',
      '#90ed7d',
      '#f7a35c',
      '#8085e9',
      '#f15c80',
      '#e4d354',
      '#2b908f',
      '#f45b5b',
      '#91e8e1'
    ];
    if (chartOptions.series) {
      for (const [index, series] of chartOptions.series.entries()) {
        series.color = colors[index];
      }
    }
    this.updateCharts();
    return chartOptions;
  }

  get startDate() {
    return CommonStore.StartDate;
  }

  set startDate(date: string) {
    CommonStore.setStartDate(date);
    this.startDateVisible = false;
  }

  get endDate() {
    return CommonStore.EndDate;
  }

  set endDate(date: string) {
    CommonStore.setEndDate(date);
    this.endDateVisible = false;
  }

  @Watch('startDate')
  async onStartDateChange() {
    await this.loadSensorProfile();
    this.updateCharts();
  }

  @Watch('endDate')
  async onEndDateChange() {
    await this.loadSensorProfile();
    this.updateCharts();
  }

  allowedStartDateOption(date: string) {
    return date <= this.endDate.replaceAll('-', '/');
  }

  allowedEndDateOption(date: string) {
    return date >= this.startDate.replaceAll('-', '/');
  }

  updateCharts() {
    this.$nextTick(() => {
      if (this.$refs.sensorProfileGraph) {
        this.$refs.sensorProfileGraph.redraw();
      }
    });
  }

  async loadSensorProfile() {
    this.loading = true;
    if (this.$route.params.sensorId) {
      this.sensorId = Number(this.$route.params.sensorId);

      // const latestDate = ConfigurationStore.LatestSeasonDate;
      await SensorStore.getSensorProfileGraphBySensorId({
        sensorId: this.sensorId,
        startDate: this.startDate,
        endDate: this.endDate
      });
    }
    if (this.$route.params.sensorLocationId) {
      this.sensorLocationId = Number(this.$route.params.sensorLocationId);
      // const latestDate = ConfigurationStore.LatestSeasonDate;
      await SensorStore.getSensorProfileGraphBySensorLocationId({
        sensorLocationId: this.sensorLocationId,
        startDate: this.startDate,
        endDate: this.endDate
      });
    }

    this.loading = false;
  }
  created() {
    this.loadSensorProfile();
  }
}
